module.exports = "/_next/static/images/tokopedia-992c327c10cde1d945713ee6f8bbb242.svg";